import type { ArtifactPreview } from "~/services/artifacts";
import { ArtifactShell } from "./ArtifactShell";

// VALUE artifacts wrap a single scalar / dict / list (pickled on the
// backend). Render as pretty JSON since there's no richer structure to
// exploit at this layer.
export const ValueArtifact = ({ preview }: { preview: ArtifactPreview }) => {
  const text =
    typeof preview.content === "string"
      ? preview.content
      : JSON.stringify(preview.content, null, 2);
  return (
    <ArtifactShell preview={preview}>
      <pre className="max-h-72 overflow-auto py-2 font-mono text-[0.8125rem] leading-5">{text}</pre>
    </ArtifactShell>
  );
};
